var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.duoChatAvailable)?_c('gl-button',_vm._b({on:{"click":_vm.onClick}},'gl-button',{ icon: 'tanuki-ai', ..._vm.buttonOptions },false),[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }